const options = {year: 'numeric', month: 'numeric', day: 'numeric' };
    
export const convertDate = (date) => {
    return new Date(date).toLocaleDateString('en-EN', options)
};